import styled from '@emotion/styled';

export const IconsWrapperStyled = styled.div`
  display: flex;
  margin-left: auto;
  gap: 4px;
`;
